import GdprModalComponent from './gdprModal.component';

export * from './gdprModal.component';
export default GdprModalComponent;
